<template lang="pug">
  .wrap
    TransitionHero(text="Derecho a las Identidades")
    .text
      .credits(v-html="article.credits")
      Sharer(:baseurl="config.baseurl", :slug="$route.path", :title="article.title || config.title", :description="article.downtitle || config.description", :img="article.shareimg || config.img", :hashtag="config.hashtag", :brandtitle="config.brandtitle", :reporttitle="config.reporttitle")
      Content(:article="article", contentType="section")
</template>

<script>
import { mapState } from 'vuex'
import TransitionHero from '@/components/transition/TransitionHero'
import Content from '@/components/Content'
import Sharer from '@/components/Sharer'

export default {
  components: {
    TransitionHero,
    Content,
    Sharer
  },
  computed: {
    article(){
      const article = this.$store.getters.getSection(this.$route.path)
      if(typeof article === 'undefined'){
        this.$router.push({name: 'home'})
      }
      return article
    },
    ...mapState([
      'config'
    ])
  }
}
</script>
<style lang="scss" scoped>

</style>
